import { useMeQuery } from '@shared/api';
import { useActionPermission } from '@entities/user';
import { useEconPermission } from '@entities/economic/types';

export interface PrcAccess {
  /** `/auth/me` загружен — до этого права считаются отсутствующими. */
  loaded: boolean;
  canRead: boolean;
  canWrite: boolean;
  isApprover: boolean;
  /** Роль разрешает утверждать свою версию (по умолчанию — только admin). */
  approveOwn: boolean;
  roles: readonly string[];
  userId: string | null;
}

/**
 * Права на экране ПРЦ: чтение и правка — права агента «Экономист», утверждение
 * и возврат — право-действие `econ.prc.approve` (по умолчанию «Главный
 * экономист», «Гендиректор», «Руководитель», администратор; миграция 0301).
 * Пока `/auth/me` грузится — всё выключено.
 */
export function usePrcAccess(): PrcAccess {
  const { data: me } = useMeQuery();
  const { can_read, can_write } = useEconPermission();
  const approval = useActionPermission('econ.prc.approve');
  const roles = me?.roles ?? [];
  return {
    loaded: Boolean(me),
    canRead: can_read || can_write,
    canWrite: can_write,
    isApprover: approval.allowed,
    approveOwn: approval.allowOwn,
    roles,
    userId: me?.user.id ?? null,
  };
}
